import { useMutation } from "@tanstack/react-query";

import { ApiError } from "@config/apiClient";
import relationService from "@services/relation.service";
import ToastService from "@services/toast.service";
import { ERROR_STRINGS, ERROR_MESSAGES } from "@config/messages";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";
import { DisconnectedError } from "@app-types/errors";
import { CREATE_BATCH_OBJECT_TAGS_MUTATION_KEY } from "@config/query";
import { IBatchRelationsBody } from "@interfaces/relation.interface";

/**
 * Custom hook to add a batch of new tags to an object based on its content type.
 */
export function useAddBatchTags() {
  const { notifyBugsnag } = useBugsnagErrorHandler();

  return useMutation({
    mutationKey: [CREATE_BATCH_OBJECT_TAGS_MUTATION_KEY],
    mutationFn: async (data: IBatchRelationsBody) => {
      return await relationService.addBatchTags(data);
    },
    onSuccess: () => {},
    onError: (error) => {
      if (error instanceof DisconnectedError) return;
      notifyBugsnag(error, ERROR_STRINGS.ADD_TAG);
      ToastService.showError(error as ApiError, ERROR_MESSAGES.ADD_TAG);
    },
  });
}
